import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import nnLogo from "../assets/images/gymfitorangelogo22.png";

// const loadImageAsBase64 = (url) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();

//     img.crossOrigin = "anonymous";

//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = img.width;
//       canvas.height = img.height;

//       const ctx = canvas.getContext("2d");
//       ctx.drawImage(img, 0, 0);

//       resolve(canvas.toDataURL("image/png"));
//     };

//     img.onerror = reject;

//     img.src = url;
//   });
// };

export const exportMembersPDF = async (members, gym) => {
  const doc = new jsPDF({
    orientation: "landscape",
  });
  // ==========================
  // Gym Logo (Left)
  // ==========================

  if (gym?.logoBase64) {
    try {
      doc.addImage(gym.logoBase64, "PNG", 14, 10, 20, 20);
    } catch (error) {
      console.log(error);
    }
  }

  // ==========================
  // Company Logo (Right)
  // ==========================

  try {
    doc.addImage(nnLogo, "PNG", 260, 10, 18, 18);
  } catch (error) {
    console.log(error);
  }

  // ==========================
  // Gym Header
  // ==========================

  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);

  // doc.text(gym?.gymName || "Gym Management System", 14, 18);
  doc.text(gym?.gymName || "Gym Management System", 40, 18);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(`Owner : ${gym?.ownerName || "-"}`, 40, 28);
  doc.text(`Phone : ${gym?.phone || "-"}`, 40, 34);
  doc.text(`Email : ${gym?.email || "-"}`, 40, 40);
  doc.text(`Address : ${gym?.address || "-"}`, 40, 46);

  doc.setLineWidth(0.5);

  doc.line(14, 50, 280, 50);

  // ==========================
  // Report Title
  // ==========================

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);

  doc.text("Gym Members Report", 110, 60);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(`Generated On : ${new Date().toLocaleString()}`, 14, 68);

  // ==========================
  // Summary
  // ==========================

  const activeMembers = members.filter((m) => m.status === "Active").length;

  const expiredMembers = members.filter((m) => m.status !== "Active").length;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);

  doc.text("Report Summary", 14, 78);

  doc.setFont("helvetica", "normal");

  doc.text(`Total Members : ${members.length}`, 14, 86);
  doc.text(`Active Members : ${activeMembers}`, 14, 92);
  doc.text(`Expired Members : ${expiredMembers}`, 14, 98);

  // ==========================
  // Members Table
  // ==========================

  autoTable(doc, {
    startY: 108,

    head: [
      [
        "ID",
        "Member Name",
        "Phone",
        "Trainer",
        "Plan",
        "Join Date",
        "Expiry Date",
        "Payment",
        "Status",
      ],
    ],

    body: members.map((m) => [
      m.memberId || "-",
      m.fullName || "-",
      m.phone || "-",
      m.trainerName || "-",
      m.membershipPlan || "-",
      m.joinDate || "-",
      m.expiryDate || "-",
      m.paymentStatus || "Paid",
      m.status || "-",
    ]),

    styles: {
      fontSize: 9,
      cellPadding: 3,
      valign: "middle",
      overflow: "linebreak",
    },

    headStyles: {
      fillColor: [33, 150, 243],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
    },

    bodyStyles: {
      halign: "center",
    },

    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },

    didParseCell: function (data) {
      if (data.section === "body" && data.column.index === 8) {
        if (data.cell.raw === "Active") {
          data.cell.styles.textColor = [34, 139, 34];
          data.cell.styles.fontStyle = "bold";
        }

        if (data.cell.raw === "Expired") {
          data.cell.styles.textColor = [220, 20, 60];
          data.cell.styles.fontStyle = "bold";
        }
      }
    },

    didDrawPage: function (data) {
      const pageSize = doc.internal.pageSize;

      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();

      const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

      doc.setFontSize(10);

      doc.setFont("helvetica", "italic");

      doc.text("Powered By NN FIT", 14, pageHeight - 10);

      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        pageWidth - 30,
        pageHeight - 10,
      );
    },
  });

  doc.save("Gym_Members_Report.pdf");
};
